import type { TFunction } from 'i18next';
import { UserRole } from '../contexts/AuthContext';

export const getRoleLabel = (role: string, t: TFunction): string => {
  switch (role) {
    case UserRole.OPERATOR:
      return t('common.roles.operator', 'Operator');
    case UserRole.MANAGER:
      return t('common.roles.manager', 'Manager');
    case UserRole.ACCOUNTANT:
      return t('common.roles.accountantAdministration', 'Contabilita amministrazione');
    case UserRole.ADMIN:
      return t('common.roles.admin', 'Admin');
    case UserRole.SUPER_ADMIN:
      return t('common.roles.superAdmin', 'Super Admin');
    default:
      return role;
  }
};